import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { Children } from 'react';
import StackView from '../StackView';

function Column() {
  return null;
}

function ColumnView(props) {
  var children = props.children,
      _props$sizes = props.sizes,
      sizes = _props$sizes === void 0 ? [] : _props$sizes,
      spacing = props.spacing,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "sizes", "spacing"]);

  var sortedColumns = Children.toArray(children).sort(function (a, b) {
    return (a.props.order || 0) - (b.props.order || 0);
  }).reduce(function (columns, cell, index) {
    var columnIndex = cell.props.index === undefined ? index : cell.props.index;

    if (!columns[columnIndex]) {
      columns[columnIndex] = [];
    }

    columns[columnIndex].push(cell);
    return columns;
  }, []);
  return /*#__PURE__*/React.createElement(StackView, _extends({
    axis: "horizontal",
    grow: 1,
    shrink: 1
  }, restProps), sortedColumns.map(function (column, index) {
    var size = sizes ? sizes[index] || 'auto' : 'auto';
    return /*#__PURE__*/React.createElement(StackView, {
      key: index,
      basis: size === 'auto' ? '100%' : size.basis || size,
      shrink: size === 'auto' ? 1 : size.shrink || 0,
      grow: size === 'auto' ? 1 : size.grow || 0,
      marginLeft: index === 0 ? null : spacing,
      spacing: spacing
    }, column.map(function (cell) {
      return cell.props.children;
    }));
  }));
}

ColumnView.Column = Column;
export default ColumnView;